import {createRoot} from "react-dom/client";
import { model } from "./MagicModel.js";
import { ReactRoot } from "./ReactRoot.jsx";
import { observable, configure, reaction } from "mobx";
import BackgroundContainer from "./reactjs/backgroundContainer.jsx";


import React from "react";

//const result = await searchInfo()
//json2Object('./', 'characters.json')
//var fs = require('fs');

const reactiveModel= observable(model);
createRoot(document.getElementById('root'))
    .render(
        <div>
        
        <ReactRoot model={reactiveModel}/>
        <BackgroundContainer>
        </BackgroundContainer>
        </div>
    );  

window.myModel= reactiveModel;  


import { connectToFirebase } from "./firebaseModel.js";
connectToFirebase(reactiveModel, reaction);



